"use strict";
import Cropper from "cropperjs";
import 'bootstrap-slider';
import 'cropperjs/src/css/cropper.scss';

export default function (image, cropperRatio = 1, readyCallback = null) {
    let cropper = new Cropper(image, {
            aspectRatio: cropperRatio || 1, //Define the fixed aspect ratio of the crop box. By default, the crop box is free ratio.
            modal: false, //Show the black modal above the image and under the crop box.
            viewMode: 0, //no restrictions to canvas size.
            center: false, //Show the center indicator above the crop box.
            dragMode: 'move', // move the canvas
            zoomable: true, //Enable to zoom the image.
            zoomOnWheel: true, //Enable to zoom the image by wheeling mouse.
            wheelZoomRatio: 0.02, //Define zoom ratio when zooming the image by wheeling mouse.
            zoomOnTouch: true, //Enable to zoom the image by dragging touch.
            cropBoxMovable: false,
            cropBoxResizable: false,
            toggleDragModeOnDblclick: false,
            guides: false,
            autoCrop: true,
            autoCropArea: 1, //A number between 0 and 1. Define the automatic cropping area size (percentage).
            restore: true, //Restore the cropped area after resizing the window.
            movable: true,
            rotatable: true,
            background: true, // Show the grid background of the container.
            highlight: true, //Show the white modal above the crop box (highlight the crop box).
            responsive: true, //Re-render the cropper when resizing the window.
        }
    )

    cropper.onZoom = function (event) {} // placeholder
    cropper.sliderElement = null; // placeholder

    cropper.options.ready = function () {
        this.cropper.resetCropperSizes();
        image.addEventListener('zoom', (event) => {
            this.cropper.onZoom(event);
        });
        if (readyCallback) readyCallback();
    }
    cropper.resetCropperSizes = function () {
        let container = this.getContainerData();
        this.setCanvasData(container);
        let canvas = this.getCanvasData();
        this.setCropBoxData(canvas); // Applies aspect ratio

        // Adjust canvas size
        if (canvas.height <= container.height) {
            this.setCanvasData({height: container.height});
        } else {
            this.setCanvasData({width: container.width});
        }
        // Adjust canvas position
        canvas = this.getCanvasData();
        this.setCanvasData({
            top: -Math.ceil((canvas.height-container.height)/2),
            left: -Math.ceil((canvas.width-container.width)/2)
        });

        // Add cropper position
        this.setCropBoxData({top:0, left: (container.width-this.getCropBoxData().width)/2});

        if (this.sliderElement) {
            this.sliderElement.slider('setValue', 0, true, false);
        }
    }

    cropper.fullReset = function () {
        this.reset();
        this.resetCropperSizes();
    }

    cropper.attachResetButton = function (element) {
        this.resetElement = element;
        let context = this;
        element.on('click', function (event) {
            context.fullReset();
        })
    }

    cropper.attachRotateButton = function (element) {
        this.rotateElement = element;
        let context = this;
        element.on('click', function (event) {
            context.rotate(90);
        })
    }

    cropper.attachSlider = function (element, btnPlus = null, btnMinus=null) {
        this.sliderElement = element;
        let wheelUnit = this.options.wheelZoomRatio;
        let sliderUnit = 0.01;
        let context = this;
        element.slider({
            min: -1, // zoom min unit
            max: 1, // zoom max unit
            step: sliderUnit,
            value: 0, // start zoom center unit
            range: false,
            handle: 'round',
            tooltip: 'hide',
        })

        element.on('change', function (event) {
            let units = (event.value.newValue - event.value.oldValue)/sliderUnit;
            context.zoom(units * wheelUnit);
        })

        if (btnPlus !== null) {
            btnPlus.click(function () {
                element.slider('setValue', element.slider('getValue') + sliderUnit, true, true)
            })
        }
        if (btnMinus !== null) {
            btnMinus.click(function () {
                element.slider('setValue', element.slider('getValue') - sliderUnit, true, true)
            })
        }

        // In case of wheel zoom - update slider
        context.onZoom = function (event) {
            if (event.detail.originalEvent !== undefined) {
                let step = (event.detail.ratio-event.detail.oldRatio) > 0 ? sliderUnit : -sliderUnit;
                element.slider('setValue', element.slider('getValue') + step, true, false)
            }
        }
    }

    return cropper;
}
